export default __webpack_public_path__ + "static/media/Flag_of_Cook_Islands.32b56134.svg";